import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { urlPush } from '@shared/routerHistory';
import { ExternalLink } from '@shared/components/externalLink';
import { InternalLink } from '@shared/components/internalLink';
import { logTelemetry } from '@shared/utils/telemetryUtils';
import { Constants } from '@shared/utils/constants';
import { Stack, StackItem, Text } from '@fluentui/react';
import { logger } from '@src/logger';
function logSitemapClickTelemetry(url) {
    const telemetryDetails = {
        linkUrl: url
    };
    logTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.SitemapLinkClick, JSON.stringify(telemetryDetails));
    logger.info(JSON.stringify(telemetryDetails), {
        action: Constants.Telemetry.Action.Click,
        actionModifier: Constants.Telemetry.ActionModifier.SitemapLinkClick
    });
}
const SitemapColumnTokens = {
    childrenGap: 'l2'
};
export const SitemapSectionColumn = ({ title = '', linkList = [] })=>{
    return /*#__PURE__*/ _jsxs(Stack, {
        wrap: true,
        className: "sitemap_section_column",
        tokens: SitemapColumnTokens,
        children: [
            title && /*#__PURE__*/ _jsx(StackItem, {
                children: /*#__PURE__*/ _jsx(Text, {
                    className: "sitemap_section_column_title",
                    variant: 'xLargePlus',
                    as: "h2",
                    children: title
                })
            }),
            linkList.map((link)=>/*#__PURE__*/ _jsx(StackItem, {
                    children: link.isExternal ? /*#__PURE__*/ _jsx(ExternalLink, {
                        className: "sitemap_link",
                        href: link.url,
                        accessibilityEnabled: true,
                        onClickHandle: ()=>logSitemapClickTelemetry(link.url),
                        children: link.title
                    }, link.title) : /*#__PURE__*/ _jsx(InternalLink, {
                        className: "sitemap_link",
                        accEnabled: true,
                        href: link.url,
                        scrollToTop: true,
                        additionalCommand: ()=>logSitemapClickTelemetry(link.url),
                        onClick: ()=>urlPush(link.url, true),
                        children: link.title
                    }, link.title)
                }, link.title))
        ]
    });
};
